import { MatTableFilterComponent } from './../mat-table-filter.component';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mat-table-filter-button',
  templateUrl: './mat-table-filter-button.component.html',
  styleUrls: ['./mat-table-filter-button.component.scss']
})
export class MatTableFilterButtonComponent implements AfterViewInit, OnDestroy {
  @ViewChild('filter_button', { static: true, read: ElementRef }) filterButton: ElementRef;
  destroy$ = new Subject();
  @Output() click: EventEmitter<null> = new EventEmitter();
  @Input() matFilter: MatTableFilterComponent;
  badgeCount = 0;
  constructor() { }
  ngAfterViewInit() {
    fromEvent(this.filterButton.nativeElement, 'click').pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.matFilter.toogle();
    });
    this.matFilter.onChangeBadge.pipe(takeUntil(this.destroy$)).subscribe(a => {
      this.badgeCount = a;
    })
  }
  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
